import { useDispatch } from 'react-redux';
import { addSelectedFlight } from '@entities/exchange';
export function useSelectFlight() {
    const dispatch = useDispatch();
    const onSelectExchangeFlight = (fare) => {
        dispatch(addSelectedFlight({ groupId: fare.fareGroupId, priceId: fare.prices[0].flight.id }));
    };
    return {
        onSelectExchangeFlight
    };
}
